import { connect } from 'react-redux';
import React from 'react';
import PropTypes from 'prop-types';

import ProgramLogos from '../components/ProgramLogos';

const WidgetContainer = props => {
	return <ProgramLogos {...props} />;
};

WidgetContainer.defaultProps = {
	programLogos: [],
	dealerCode: '',
	logoInfo: {}
};

WidgetContainer.propTypes = {
	programLogos: PropTypes.arrayOf(PropTypes.string),
	dealerCode: PropTypes.string,
	logoInfo: PropTypes.shape({})
};

const mapStateToProps = state => {
	return {
		dealerCode: state.dealerCode,
		programLogos: state.programLogos,
		logoInfo: state.logoInfo
	};
};

const Widget = connect(mapStateToProps, null)(WidgetContainer);

export default Widget;
